export default {
    byBlogPost(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('blogPostId', id).get()
            )
        )
    }
}
